import { motion } from "framer-motion";
import { CalendarDays, GraduationCap, Layers3, Rocket, Star } from "lucide-react";
import { stats } from "../data";

const icons = [CalendarDays, GraduationCap, Layers3, Rocket, Star];

export default function About() {
  return (
    <section id="about" className="section-shell">
      <motion.div
        initial={{ opacity: 0, y: 28 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.25 }}
        transition={{ duration: 0.6 }}
        className="mx-auto max-w-3xl text-center"
      >
        <p className="text-sm font-bold uppercase tracking-[0.35em] text-cyan-200">Миний тухай</p>
        <h2 className="mt-4 font-display text-3xl font-black text-white sm:text-5xl">Миний тухай</h2>
      </motion.div>

      <div className="mt-12 grid items-start gap-6 lg:grid-cols-[1fr_0.92fr]">
        <motion.div
          initial={{ opacity: 0, x: -28 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.65 }}
          className="glass-card p-6 sm:p-8"
        >
          <p className="text-base leading-8 text-slate-300">
            Би 2023 онд Шинжлэх Ухаан Технологийн Их Сургууль-ийн Мэдээлэл, Холбооны Технологийн Сургуульд
            элсэн орсон, Компьютерын ухааны 3-р курсийн оюутан. Программ хангамж хөгжүүлэлт, frontend/backend
            систем, microservice architecture, UI/UX дизайн болон data analysis чиглэлээр суралцаж байна.
          </p>
          <p className="mt-5 text-base leading-8 text-slate-300">
            Java, Python, React, Spring Boot, Docker зэрэг технологи ашиглан лаборатори, бие даалт болон mini
            project-үүд хийж байсан. Одоо дадлага болон entry-level хөгжүүлэлтийн боломжид өөрийгөө сориход
            бэлэн байна.
          </p>
        </motion.div>

        <div className="grid gap-4 sm:grid-cols-2">
          {stats.map((stat, index) => {
            const Icon = icons[index];
            return (
              <motion.div
                key={stat.label}
                initial={{ opacity: 0, y: 24 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.55, delay: index * 0.07 }}
                className="glass-card group p-4 transition duration-300 hover:-translate-y-1 hover:border-cyan-300/35 hover:shadow-glow sm:p-5"
              >
                <Icon className="mb-5 text-cyan-200" size={24} />
                <p className="text-2xl font-black text-white sm:text-3xl">{stat.value}</p>
                <p className="mt-1 text-sm font-medium text-slate-400">{stat.label}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
